<template>
    <section class="banner_promotions" v-if="banner">
        <div class="inner_banner_content">
            <h2>{{banner.title}}</h2>
            <p>{{banner.description}}</p>
            <a :href="banner.link" class="btn">{{banner.textbutton}}</a>
        </div>
        <img :src="banner.image.desktop" :alt="banner.title" class="banner_promotions_bg">
    </section>
</template>

<script>

import BannerService from "../../providers/api/banner-service";
import Loading from "../loading";

let bannerService = new BannerService();

export default {
    name: 'banner-promotions',
	data: () => {
		return {
            banner: false,
		}
	},
	mounted() {
    	this.loadBanner();
	},
	methods: {
		loadBanner(){
			this.isLoading = true;

			const params = {
				perPage: 1
			};
			bannerService.doGetByType(102, params).then((res) => {
				this.banner = res.data.data[0];
				console.log("this banner is ", this.banner);
				
				this.isLoading = false;
			})
			.catch(() => this.isLoading = false);
		}

	}
}
</script>



// WEBPACK FOOTER //
// resources/site/js/components/banners/banner-promotions.vue